const relatedStoriesSlider = $('.thor-posts-list-slider .slider')

relatedStoriesSlider.not('.slick-initialized').each(function () {
  const prevArrow = $(this).siblings('.prev-arrow');
  const nextArrow = $(this).siblings('.next-arrow');

  const arrowMobile = $(this).siblings('.slider-mobile-arrows');
  const arrowPrevMobile = arrowMobile.find('.prev-arrow.mobile');
  const arrowNextMobile = arrowMobile.find('.next-arrow.mobile');


  $(this).slick({
    autoplay: false,
    slidesToShow: 3,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          prevArrow: arrowPrevMobile,
          nextArrow: arrowNextMobile,
          slidesToShow: 1,
        },
      },
    ],
  })
});


// WEBPACK FOOTER //
// ./scripts/blocks/slider-block.js